var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "79", height: "77", viewBox: "0 0 79 77" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#F9A18A", d: "M18 40h43v12H18zm0-18h43v12H18z" }),
      React.createElement("path", { fill: "#F7E88B", d: "M5 0h69v15H5z" }),
      React.createElement("path", { fill: "#88C5FC", d: "M0 65h21v12H0zm29 0h21v12H29zm29 0h21v12H58z" }),
      React.createElement("path", { fill: "#B3B3B3", d: "M37.91 33.56H41v6.49h-3.08zm0 18.47H41v12.85h-3.08zm0-36.94H41v6.5h-3.08zM12.1 64.9H9V44.84h8.82v3.11h-5.75zm57.81 0h-3.08V47.96h-5.74v-3.12h8.82z" })
    )
  );
});